(() => {
  if (customElements.get('schwarz-ankaufsrechner')) return;
  const assetURL = document.currentScript ? document.currentScript.src : '';
  const names = {gold:'Gold',silver:'Silber',platinum:'Platin',palladium:'Palladium'};
  const euro = new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'});
  const date = new Intl.DateTimeFormat('de-DE',{dateStyle:'short',timeStyle:'short',timeZone:'Europe/Berlin'});
  const escape = value => String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function grams(value) {
    const text=value.trim().replace(',','.');
    if (!text) return 0;
    if (!/^\d+(?:\.\d{1,3})?$/.test(text)) return null;
    const number=Number(text);
    return Number.isFinite(number)&&number<=100000 ? Math.round(number*1000) : null;
  }
function ankaufPDF(items,total,timestamp,stale,prices,logo,saved,qr) {
  const number=new Intl.NumberFormat('de-DE',{minimumFractionDigits:2,maximumFractionDigits:3});
  function hex(value){return Array.from(String(value)).map(c=>{let n=c.charCodeAt(0);if(n===8364)n=128;else if(n===8211||n===8212)n=45;else if(n>255)n=63;return n.toString(16).padStart(2,'0')}).join('')}
  const pages=[];let commands=[],y=0;
  function text(value,x,at,size=10,bold=false,color='0.09 0.09 0.09') {commands.push(`${color} rg BT /${bold?'F2':'F1'} ${size} Tf 1 0 0 1 ${x} ${at} Tm <${hex(value)}> Tj ET`)}
  function right(value,x,at,size=10,bold=false){let width=0;for(const c of String(value))width+=('0123456789€'.includes(c)?0.556:' .,:;!|'.includes(c)?0.278:'ilI'.includes(c)?0.278:'mwMW'.includes(c)?0.9:0.62)*size;text(value,x-width,at,size,bold)}
  function line(at){commands.push(`0.6000 0.7255 0.8000 RG 0.6 w 195 ${at} m 565 ${at} l S`)}
  function page(){
    if(commands.length)pages.push(commands.join('\n')+'\n');commands=[];
    commands.push('0.96 0.97 0.98 rg 0 0 174 842 re f');
    const height=145*logo.height/logo.width;
    commands.push(`q 145 0 0 ${height} 14 ${795-height} cm /Logo Do Q`);
    text('Ankaufsübersicht',14,706,15,true);
    text('Edelmetalle',14,686,15,true);
    text('Erstellt am',14,661,9);
    text(date.format(new Date())+' Uhr',14,647,9);
    commands.push('0.6000 0.7255 0.8000 RG 2 w 14 631 m 160 631 l S');
    text('IHR ANSPRECHPARTNER',14,606,8,true);
    text('Schwarz Trauringe GmbH',14,585,9,true);
    ['Neue Mitte 28','35415 Pohlheim','Deutschland','','Tel: 06403 / 976920','Fax: 06403 / 9769223','','info@schwarz-trauringe.de','schwarz-trauringe.de'].forEach((v,i)=>text(v,14,565-i*15,8));
    text('Preisstand',14,365,8,true);
    text(date.format(new Date(timestamp*1000))+' Uhr',14,350,8);
    if(stale){text('Letzter verfügbarer Stand',14,329,8);text('Aktualisierung verzögert',14,315,8)}
    text('Zusammenfassung',195,790,20,true);
    text('Alle Werte zur Orientierung. Endgültiger Ankaufpreis',195,765,9);
    text('nach Prüfung des Materials und des Edelmetallgewichts.',195,751,9);
    const qrSize=124,quiet=4,modules=qr.length,cell=qrSize/(modules+quiet*2);
    commands.push('1 1 1 rg 14 182 124 124 re f');
    commands.push('0 0 0 rg');
    for(let row=0;row<modules;row++)for(let col=0;col<modules;col++)if(qr[row][col]){
      const x=14+(col+quiet)*cell,at=182+(modules-row-1+quiet)*cell;
      commands.push(`${x.toFixed(4)} ${at.toFixed(4)} ${cell.toFixed(4)} ${cell.toFixed(4)} re f`);
    }
    text('Für einen aktuellen Preis scannen',14,165,8);
    text('Berechnungs-ID',14,144,8,true);
    text(saved.id.match(/.{1,4}/g).join('-'),14,130,8);
    text('ID online im Ankaufsrechner',14,109,8);
    text('eingeben oder QR-Code scannen.',14,95,8);
    y=715;
  }
  page();
  const populated=Object.keys(names).filter(material=>items.some(item=>item.material===material));
  for(const material of populated){
    const rows=items.filter(i=>i.material===material);if(!rows.length)continue;
    const needed=94+rows.length*22+(material===populated[populated.length-1]?100:0);
    if(y-needed<105)page();
    text(names[material],195,y,12,true);
    right('Feinmetall: '+euro.format(prices[material])+' / g',565,y,9);
    line(y-10);y-=31;
    text('Legierung',200,y,9,true);text('Gewicht (g)',383,y,9,true);text('Wert',536,y,9,true);
    y-=23;let subtotal=0;
    for(const item of rows){
      text(item.label==='Zahngold'?'Zahngold':names[material]+' '+item.label,200,y,10);
      right(number.format(item.weight),440,y,10);
      right(euro.format(item.cents/100),560,y,10);
      commands.push(`0.88 0.91 0.93 RG 0.4 w 195 ${y-8} m 565 ${y-8} l S`);
      subtotal+=item.cents;y-=22;
    }
    y-=4;
    right('Zwischensumme '+names[material]+': '+euro.format(subtotal/100),560,y,10,true);
    y-=36;
  }
  if(y<185)page();
  commands.push(`0.6000 0.7255 0.8000 rg 195 ${y-16} 370 42 re f`);
  text('Gesamtsumme',207,y,12,true);right(euro.format(total/100),553,y,16,true);
  y-=48;
  ['Unverbindliche Berechnung, kein verbindliches Ankaufsangebot.',
   'Feingehalt und Edelmetallgewicht werden beim Ankauf geprüft.',
   'Steine und andere Bestandteile zählen nicht zum Edelmetallgewicht.',
   'Der Feingehalt von Zahngold wird individuell geprüft.'].forEach((v,i)=>text(v,195,y-i*13,8));
  pages.push(commands.join('\n')+'\n');
  const objects=[];const add=value=>{objects.push(value);return objects.length};
  const catalog=add('');const tree=add('');
  const font=add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
  const bold=add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');
  const image=add(`<< /Type /XObject /Subtype /Image /Width ${logo.width} /Height ${logo.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter [/ASCIIHexDecode /DCTDecode] /Length ${logo.hex.length+2} >>\nstream\n${logo.hex}>\nendstream`);
  const annotation=add(`<< /Type /Annot /Subtype /Link /Rect [14 182 138 306] /Border [0 0 0] /A << /S /URI /URI (${saved.url.replace(/([\\()])/g,'\\$1')}) >> >>`);
  const ids=[];
  pages.forEach((stream,index)=>{
    const footer=`0.35 0.35 0.35 rg BT /F1 8 Tf 1 0 0 1 495 35 Tm <${hex('Seite '+(index+1)+' / '+pages.length)}> Tj ET\n`;
    const content=stream+footer;
    const contentId=add(`<< /Length ${content.length} >>\nstream\n${content}endstream`);
    ids.push(add(`<< /Type /Page /Parent ${tree} 0 R /MediaBox [0 0 595.28 841.89] /Resources << /Font << /F1 ${font} 0 R /F2 ${bold} 0 R >> /XObject << /Logo ${image} 0 R >> >> /Contents ${contentId} 0 R /Annots [${annotation} 0 R] >>`));
  });
  objects[catalog-1]=`<< /Type /Catalog /Pages ${tree} 0 R >>`;
  objects[tree-1]=`<< /Type /Pages /Kids [${ids.map(id=>id+' 0 R').join(' ')}] /Count ${ids.length} >>`;
  let pdf='%PDF-1.4\n';const offsets=[0];
  objects.forEach((object,index)=>{offsets.push(pdf.length);pdf+=`${index+1} 0 obj\n${object}\nendobj\n`});
  const start=pdf.length;
  pdf+=`xref\n0 ${objects.length+1}\n0000000000 65535 f \n`;
  offsets.slice(1).forEach(offset=>pdf+=String(offset).padStart(10,'0')+' 00000 n \n');
  pdf+=`trailer\n<< /Size ${objects.length+1} /Root ${catalog} 0 R >>\nstartxref\n${start}\n%%EOF\n`;
  return pdf;
}
async function ankaufLogo(){
  const element=document.querySelector('.header-logo img')||document.querySelector('img.header-logo__image');
  if(!element)throw new Error('Das Firmenlogo wurde nicht gefunden.');
  const source=element.currentSrc||element.src;
  const image=new Image();image.crossOrigin='anonymous';
  await new Promise((resolve,reject)=>{
    const timer=setTimeout(()=>reject(new Error('Logo konnte nicht geladen werden.')),15000);
    image.onload=()=>{clearTimeout(timer);resolve()};image.onerror=()=>{clearTimeout(timer);reject(new Error('Logo konnte nicht geladen werden.'))};image.src=source;
  });
  const canvas=document.createElement('canvas');canvas.width=600;canvas.height=Math.round(600*image.naturalHeight/image.naturalWidth);
  const context=canvas.getContext('2d');context.fillStyle='#f5f7f9';context.fillRect(0,0,canvas.width,canvas.height);context.drawImage(image,0,0,canvas.width,canvas.height);
  const binary=atob(canvas.toDataURL('image/jpeg',0.92).split(',')[1]);
  let hex='';for(let i=0;i<binary.length;i++)hex+=binary.charCodeAt(i).toString(16).padStart(2,'0');
  return {width:canvas.width,height:canvas.height,hex};
}

async function ankaufQR(url){
  if(!assetURL)throw new Error('QR-Modul konnte nicht geladen werden.');
  const module=await import(new URL('qr-code-generator.js',assetURL).href);
  const holder=document.createElement('div');
  const generated=new module.QRCode(holder,{text:url,width:256,height:256,useSVG:true,correctLevel:1});
  const model=generated._oQRCode,count=model.getModuleCount();
  return Array.from({length:count},(_,row)=>Array.from({length:count},(_,col)=>model.isDark(row,col)));
}
  class SchwarzAnkauf extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-status]')) {
        if (!this.initPending) {
          this.initPending = true;
          requestAnimationFrame(() => { this.initPending = false; if (this.isConnected) this.connectedCallback(); });
        }
        return;
      }
      if (this.started) return;
      this.started=true;this.rates=null;this.lastTry=0;this.loading=false;
      this.status=this.querySelector('[data-status]');this.cards=this.querySelector('[data-cards]');
      this.grand=this.querySelector('[data-grand]');this.validation=this.querySelector('[data-validation]');
      this.printButton=this.querySelector('[data-print]');this.retry=this.querySelector('[data-retry]');
      this.querySelector('.sak__saved-tools')?.remove();
      this.tools=document.createElement('div');this.tools.className='sak__saved-tools';
      this.tools.innerHTML='<style>.sak__saved-tools{margin:0 0 24px;padding:18px;background:#f4f7f9;font-size:13px}.sak__saved-tools label{display:block;margin-bottom:8px}.sak__saved-tools .sak__id-row{display:flex;flex-wrap:wrap;gap:10px}.sak .sak__saved-tools input{max-width:280px;text-align:left}.sak__saved-tools button{padding:10px 16px;background:#171717;color:#fff;border:0;font:inherit;cursor:pointer}.sak__saved-tools button:disabled{opacity:.5;cursor:not-allowed}.sak__saved-tools p{margin:12px 0 0;line-height:1.6}.sak__saved-tools strong{letter-spacing:1px}</style><label>Gespeicherte Berechnung laden</label><div class="sak__id-row"><input data-lookup placeholder="Berechnungs-ID" aria-label="Berechnungs-ID" autocomplete="off"><button type="button" data-load-id>Berechnung laden</button><button type="button" data-save-id disabled>Aktuelle Eingaben speichern</button></div><p data-id-message role="status" aria-live="polite"></p>';
      this.cards.before(this.tools);
      this.lookup=this.tools.querySelector('[data-lookup]');this.idMessage=this.tools.querySelector('[data-id-message]');this.saveButton=this.tools.querySelector('[data-save-id]');
      this.tools.querySelector('[data-load-id]').onclick=()=>this.loadSaved(this.lookup.value);
      this.lookup.onkeydown=event=>{if(event.key==='Enter'){event.preventDefault();this.loadSaved(this.lookup.value)}};
      this.saveButton.onclick=async()=>{this.calculate();if(!this.calculation?.items.length)return;this.saveButton.disabled=true;try{await this.ensureSaved(this.calculation.items)}catch(error){this.idMessage.textContent=error.message}finally{this.calculate()}};
      this.pendingID=new URL(location.href).searchParams.get('berechnung');
      this.onInput=event=>{if(event.target!==this.lookup)this.calculate()};this.addEventListener('input',this.onInput);
      this.querySelector('[data-reset]').onclick=()=>{this.cards.querySelectorAll('input').forEach(i=>i.value='');this.calculate()};
      this.printButton.onclick=()=>this.print();this.retry.onclick=()=>this.load(true);
      this.onWake=()=>{if(!document.hidden)this.load()};
      document.addEventListener('visibilitychange',this.onWake);window.addEventListener('focus',this.onWake);
      this.timer=setInterval(()=>{if(!document.hidden)this.load()},600000);
      this.load(true);
    }
    disconnectedCallback() {
      clearInterval(this.timer);this.controller?.abort();
      document.removeEventListener('visibilitychange',this.onWake);window.removeEventListener('focus',this.onWake);
      this.removeEventListener('input',this.onInput);this.started=false;
    }
    async load(force=false) {
      if(this.loading||(!force&&Date.now()-this.lastTry<60000))return;
      this.loading=true;this.lastTry=Date.now();this.retry.hidden=true;
      this.controller=new AbortController();const timeout=setTimeout(()=>this.controller.abort(),20000);
      try {
        const response=await fetch(this.dataset.api+'/rates',{signal:this.controller.signal,credentials:'omit',cache:'no-store'});
        if(!response.ok)throw new Error('Preise nicht verfügbar');
        const data=await response.json();
        if(data.success!==true||data.currency!=='EUR'||data.unit!=='gram'||!Number.isFinite(data.timestamp)||Date.now()/1000-data.timestamp>7200)throw new Error('Preisstand zu alt');
        const ids=new Set();
        for(const material of Object.keys(names)){
          if(!Array.isArray(data.materials?.[material])||!Number.isFinite(data.prices?.[material]))throw new Error('Unvollständige Preise');
          for(const row of data.materials[material]){
            if(typeof row.id!=='string'||!row.id.startsWith(material+'-')||ids.has(row.id)||!Number.isFinite(row.eurPerGr)||row.eurPerGr<=0)throw new Error('Ungültige Preise');
            ids.add(row.id);
          }
        }
        if(ids.size!==16)throw new Error('Unvollständige Legierungen');
        this.rates=data;this.render();
        this.status.classList.remove('is-error');
        this.status.textContent=(data.stale?'Letzter verfügbarer Preisstand: ':'Preisstand: ')+date.format(new Date(data.timestamp*1000))+' Uhr (Deutschland). '+(data.stale?'Die Aktualisierung ist vorübergehend verzögert.':'Metallpreise werden spätestens bei der nächsten Abfrage nach 30 Minuten aktualisiert.');
        this.calculate();
      } catch(error) {
        if(!this.isConnected)return;
        this.rates=null;this.status.classList.add('is-error');
        this.status.textContent='Aktuelle Ankaufspreise konnten nicht geladen werden. Bitte versuchen Sie es erneut. Eine Berechnung ist derzeit nicht möglich.';
        this.retry.hidden=false;this.grand.textContent='—';this.printButton.disabled=true;
        this.querySelectorAll('[data-unit],[data-value],[data-group-total]').forEach(el=>el.textContent='—');
        this.cards.querySelectorAll('input').forEach(input=>input.disabled=true);this.saveButton.disabled=true;
      } finally {clearTimeout(timeout);this.loading=false}
      if(this.rates&&this.pendingID){const id=this.pendingID;this.pendingID=null;this.loadSaved(id)}
    }
    render() {
      const old={};this.cards.querySelectorAll('input').forEach(i=>old[i.dataset.id]=i.value);
      const opened=new Set([...this.cards.querySelectorAll('details[open]')].map(d=>d.dataset.group));
      const first=!this.cards.children.length;this.cards.replaceChildren();
      const groups=[['gold','Gold & Zahngold',['gold']],['silver','Silber',['silver']],['pp','Platin & Palladium',['platinum','palladium']]];
      for(const [group,title,materials] of groups) {
        const card=document.createElement('details');card.className='sak__card';card.dataset.group=group;
        card.open=first?group==='gold':opened.has(group);
        const spot=materials.map(m=>(m==='gold'?'Gold':m==='silver'?'Silber':m==='platinum'?'Platin':'Palladium')+': '+euro.format(this.rates.prices[m])+' / g').join(' · ');
        card.innerHTML='<summary><span class="sak__heading"><h2>'+title+'</h2><span class="sak__spot">Feinmetallkurs '+spot+'</span></span><span class="sak__heading-total"><span data-group-total="'+group+'">0,00 €</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></span></summary><table><thead><tr><th scope="col">Legierung</th><th scope="col">Gewicht (g)</th><th scope="col">Ankaufwert</th></tr></thead><tbody></tbody></table>';
        const tbody=card.querySelector('tbody');
        for(const material of materials) for(const row of this.rates.materials[material]) {
          const tr=document.createElement('tr');
          const label=document.createElement('td');label.textContent=row.isDental?'Zahngold':(material==='gold'?'Gold ':material==='silver'?'Silber ':material==='platinum'?'Platin ':'Palladium ')+row.label;tr.append(label);
          const cell=document.createElement('td');const input=document.createElement('input');
          input.type='text';input.inputMode='decimal';input.autocomplete='off';input.placeholder='0';input.maxLength=10;
          input.dataset.id=row.id;input.value=old[row.id]||'';input.setAttribute('aria-label',label.textContent+': Gewicht in Gramm');
          cell.append(input);tr.append(cell);
          const value=document.createElement('td');value.dataset.value=row.id;value.textContent='0,00 €';tr.append(value);tbody.append(tr);
        }
        this.cards.append(card);
      }
    }
    calculate() {
      if(!this.rates)return;
      if(Date.now()/1000-this.rates.timestamp>7200){this.grand.textContent='—';this.printButton.disabled=true;this.load(true);return}
      let total=0,invalid=false;const items=[];const groupTotals={gold:0,silver:0,pp:0};const groupBad={gold:false,silver:false,pp:false};
      for(const [material,rows] of Object.entries(this.rates.materials)){
        let subtotal=0,bad=false;
        for(const row of rows){
          const input=[...this.querySelectorAll('input')].find(i=>i.dataset.id===row.id);
          const weight=grams(input.value);input.setAttribute('aria-invalid',weight===null?'true':'false');
          const value=[...this.querySelectorAll('[data-value]')].find(i=>i.dataset.value===row.id);
          if(weight===null){invalid=true;bad=true;value.textContent='—';continue}
          const cents=Math.round(weight*Math.round(row.eurPerGr*100)/1000);
          value.textContent=euro.format(cents/100);subtotal+=cents;
          if(weight>0)items.push({material,label:row.isDental?'Zahngold':row.label,weight:weight/1000,unit:row.eurPerGr,cents});
        }
        const group=(material==='platinum'||material==='palladium')?'pp':material;groupTotals[group]+=subtotal;groupBad[group]=groupBad[group]||bad;total+=subtotal;
      }
      for(const group of Object.keys(groupTotals))this.querySelector('[data-group-total="'+group+'"]').textContent=groupBad[group]?'—':euro.format(groupTotals[group]/100);
      this.validation.hidden=!invalid;
      this.validation.textContent='Bitte geben Sie Gewichte zwischen 0 und 100.000 Gramm mit maximal drei Nachkommastellen ein, zum Beispiel 10,5.';
      this.grand.textContent=invalid?'—':euro.format(total/100);
      this.printButton.disabled=invalid||items.length===0||Boolean(this.pdfBusy);
      this.calculation={items,total};this.saveButton.disabled=invalid||items.length===0;
    }
    weightsFrom(items){return Object.fromEntries(items.map(i=>[i.material+'-'+(i.label==='Zahngold'?'zahngold':i.label),String(i.weight)]))}
    async ensureSaved(items){
      const weights=this.weightsFrom(items),key=JSON.stringify(weights);
      if(this.savedKey===key&&this.saved)return this.saved;
      const response=await fetch(this.dataset.api+'/calculations',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',body:JSON.stringify({weights})});
      const data=await response.json();
      if(!response.ok||data.success!==true)throw new Error(data.message||'Berechnung konnte nicht gespeichert werden.');
      const url=new URL(location.pathname,location.origin);url.searchParams.set('berechnung',data.id);
      this.saved={id:data.id,url:url.href};this.savedKey=key;
      this.idMessage.textContent='Gespeichert. Berechnungs-ID: '+data.id.match(/.{1,4}/g).join('-')+'. Die ID lädt Ihre Gewichte mit dem aktuellen Preisstand.';
      return this.saved;
    }
    async loadSaved(raw){
      const id=String(raw||'').toUpperCase().replace(/[-\s]/g,'');
      if(!/^(?:[A-HJ-NP-Z2-9]{8}|[A-Z2-7]{20})$/.test(id)){this.idMessage.textContent='Bitte eine gültige Berechnungs-ID eingeben.';return}
      this.idMessage.textContent='Gespeicherte Gewichte werden geladen …';
      try{
        const response=await fetch(this.dataset.api+'/calculations/'+id,{credentials:'omit',cache:'no-store'});const data=await response.json();
        if(!response.ok||!data.success)throw new Error(data.message||'Berechnung wurde nicht gefunden.');
        await this.load(true);if(!this.rates)throw new Error('Die Gewichte sind gespeichert, aktuelle Preise sind derzeit aber nicht verfügbar.');
        this.cards.querySelectorAll('input').forEach(input=>input.value=data.weights[input.dataset.id]||'');
        this.cards.querySelectorAll('details').forEach(details=>details.open=[...details.querySelectorAll('input')].some(i=>Number(i.value)>0));
        this.calculate();const url=new URL(location.pathname,location.origin);url.searchParams.set('berechnung',id);
        this.saved={id,url:url.href};this.savedKey=JSON.stringify(this.weightsFrom(this.calculation.items));
        this.lookup.value=id.match(/.{1,4}/g).join('-');
        this.idMessage.textContent='Gewichte geladen. Die angezeigten Werte wurden mit dem aktuellen Preisstand neu berechnet.';
      }catch(error){this.idMessage.textContent=error.message}
    }
    async print() {
      if(!this.rates||Date.now()/1000-this.rates.timestamp>7200){this.load(true);return}
      this.calculate();if(this.printButton.disabled)return;
      const original=this.printButton.textContent;this.pdfBusy=true;this.printButton.disabled=true;this.printButton.textContent='PDF wird erstellt …';
      try {
        const snapshot={items:this.calculation.items,total:this.calculation.total,timestamp:this.rates.timestamp,stale:this.rates.stale,prices:this.rates.prices};
        const saved=await this.ensureSaved(snapshot.items);
        const [logo,qr]=await Promise.all([ankaufLogo(),ankaufQR(saved.url)]);
        const pdf=ankaufPDF(snapshot.items,snapshot.total,snapshot.timestamp,snapshot.stale,snapshot.prices,logo,saved,qr);
        const blob=new Blob([pdf],{type:'application/pdf'});const url=URL.createObjectURL(blob);
        const link=document.createElement('a');link.href=url;link.download='Schwarz-Ankaufberechnung-'+new Date().toISOString().slice(0,10)+'.pdf';
        document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),60000);
      } catch(error) {this.validation.hidden=false;this.validation.textContent='Die PDF konnte nicht erstellt werden. '+error.message} finally {this.pdfBusy=false;this.printButton.textContent=original;this.calculate()}
    }
  }
  customElements.define('schwarz-ankaufsrechner',SchwarzAnkauf);
})();
